import {
    getAccordionAnchorById,
    getAccordionAnchors,
} from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionSelectors";
import { AccordionAnchorModel } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import findIndex from "lodash/findIndex";

export interface SetIsAccordionOpenParameter extends Required<AccordionAnchorModel> {}

export interface SetIsAccordionOpenHandlerProps {
    anchors: AccordionAnchorModel[];
}

type HandlerType = Handler<SetIsAccordionOpenParameter, SetIsAccordionOpenHandlerProps>;

export const PopulateAccordionAnchors: HandlerType = props => {
    const state = props.getState();
    const anchor = getAccordionAnchorById(props.getState(), props.parameter.id);
    let anchors = getAccordionAnchors(state);

    if (anchor) {
        anchors = [...anchors];
        const anchorIndex = findIndex(anchors, x => x.id === anchor.id);
        anchors.splice(anchorIndex, 1, props.parameter);
    }

    props.anchors = anchors;
};

export const DispatchSetIsAccordionOpen: HandlerType = props => {
    props.dispatch({
        type: "Toolkit/Components/Accordion/SetIsAccordionOpen",
        anchors: props.anchors,
    });
};

export const chain = [PopulateAccordionAnchors, DispatchSetIsAccordionOpen];

const setIsAccordionOpen = createHandlerChainRunner(chain, "SetIsAccordionOpen");

export default setIsAccordionOpen;
